/**
 * @param {object} item
 * @param {object} parameters
 * @param {string} parameters.html
 * @param {object} parameters.components
 * @returns {string}
 */
export function suggestedSearchTemplate(item, {html, components}) {
    return html`<a href="/search?query=${encodeURIComponent(item.name)}" data-instantsearch-query="${item.name}">${components.Highlight({
        attribute: 'name',
        hit: item,
        highlightedTagName: 'b',
    })}</a>`;
}
